// extracted by mini-css-extract-plugin
export default {"CopyToClipboardColumn":"InfoTable_CopyToClipboardColumn__i8t3N","Table":"InfoTable_Table__hOJuu"};